import React, {Component} from 'react';
import styled from "styled-components";
import PropTypes from 'prop-types';

const ContentWrapper = styled.div`
    display: inline-block;
    margin: 0;
`;

const ConfirmText = styled.div`
    display:inline;
    margin: 0.1rem 0.25rem;
    font-size: 0.9rem;
    font-style:italic;
    color: maroon;        
`;

const GenericButton = styled.button`
    padding: 0.15rem 0.25rem;
    margin-left: 0.25rem;
    cursor: pointer;
`;

export class DeleteConfirm extends Component {

    static propTypes = {
        callback_yes: PropTypes.func.isRequired,
        callback_no: PropTypes.func.isRequired,
        initial_value: PropTypes.string
    }

    state = {
        value: this.props.initial_value ? this.props.initial_value : ''
    };

    change_text(e) {
        this.setState({value: e.target.value});
    }

    render() {
        return <ContentWrapper>
            <ConfirmText
                type={"text"}
                value={this.state.value}
                onChange={e => this.change_text(e)}>
                delete item, confirm?
            </ConfirmText>
            <GenericButton
                onClick={e => this.props.callback_yes()}>
                yes
            </GenericButton>
            <GenericButton
                onClick={e => this.props.callback_no()}>
                no
            </GenericButton>
        </ContentWrapper>
    }
}

export default DeleteConfirm;

